<ng-container *ngIf="allowedPaymentMethods$ | async as allowedPaymentMethods">
    <form
        *ngIf="allowedPaymentMethods.length && form$ | async as form"
        class="a-fx-col a-fx-gap-24"
        nz-form
        [formGroup]="form"
        [ngSwitch]="paymentMethodProvider$ | async"
        (ngSubmit)="submitForm().subscribe()"
    >
        <div class="a-fx-col a-fx-gap-24">
            <nz-radio-group
                class="a-fx a-fx-start-center a-fx-gap-16"
                [ngModel]="paymentMethodProvider$ | async"
                [ngModelOptions]="{ standalone: true }"
                (ngModelChange)="setPaymentMethodProvider$.next($event)"
            >
                <label
                    *ngFor="let paymentMethod of paymentMethodProviders$ | async"
                    nz-radio
                    [nzValue]="paymentMethod.type"
                    [nzDisabled]="paymentMethod.disabled"
                    [nz-tooltip]="paymentMethod.disabled ? ('settings.payment-methods.not-available' | translate) : ''"
                >
                    {{ 'settings.payment-methods.' + paymentMethod.name | translate }}
                </label>
            </nz-radio-group>
        </div>

        <div class="adspt-form ant-row">
            <ng-container *ngSwitchCase="'CARD'">
                <adspt-stripe-input name="cardNumber" class="ant-col-12 ant-form-item">{{
                    'settings.cc.card-number' | translate
                }}</adspt-stripe-input>

                <adspt-stripe-input name="cardExpiry" class="ant-col-6 ant-form-item">{{
                    'settings.cc.expiry' | translate
                }}</adspt-stripe-input>

                <adspt-stripe-input name="cardCvc" class="ant-col-6 ant-form-item">{{
                    'settings.cc.cvv' | translate
                }}</adspt-stripe-input>

                <nz-form-item adsptFormInputStates class="ant-col-12">
                    <nz-form-label>{{ 'settings.cc.name-on-card' | translate }}</nz-form-label>

                    <nz-form-control [nzErrorTip]="'settings.cc.name-error' | translate">
                        <input nz-input formControlName="nameOnCard" placeholder="John Doe" />

                        <ng-container *ngTemplateOutlet="errorTmpl"></ng-container>
                    </nz-form-control>
                </nz-form-item>
            </ng-container>

            <ng-container *ngSwitchCase="'SEPA'">
                <nz-form-item adsptFormInputStates class="ant-col-12">
                    <nz-form-label>{{ 'settings.sepa.full-name' | translate }}</nz-form-label>

                    <nz-form-control [nzErrorTip]="'settings.sepa.name-error' | translate">
                        <input nz-input formControlName="fullName" placeholder="John Doe" />

                        <ng-container *ngTemplateOutlet="errorTmpl"></ng-container>
                    </nz-form-control>
                </nz-form-item>

                <adspt-stripe-input name="iban" class="ant-col-12 ant-form-item">{{
                    'settings.sepa.iban' | translate
                }}</adspt-stripe-input>
            </ng-container>
            <ng-container *ngSwitchCase="'ALIPAY'">
                <nz-form-item adsptFormInputStates class="ant-col-12">
                    <nz-form-label>{{ 'settings.alipay.full-name' | translate }}</nz-form-label>

                    <nz-form-control [nzErrorTip]="'settings.alipay.name-error' | translate">
                        <input nz-input formControlName="fullName" placeholder="John Doe" />

                        <ng-container *ngTemplateOutlet="errorTmpl"></ng-container>
                    </nz-form-control>
                </nz-form-item>
            </ng-container>
        </div>

        <div class="a-fx-col a-fx-gap-4">
            <p
                *ngSwitchCase="'CARD'"
                class="caption-1 a-color-secondary"
                [innerHTML]="'settings.cc.sca-note' | translate: { url: stripeSca }"
            ></p>

            <p
                *ngSwitchCase="'SEPA'"
                class="caption-1 a-color-secondary"
                [innerHTML]="'settings.sepa.sca-note' | translate"
            ></p>

            <p
                *ngSwitchCase="'ALIPAY'"
                class="caption-1 a-color-secondary"
                [innerHTML]="'settings.alipay.sca-note' | translate"
            ></p>

            <img class="stripe-logo" [src]="'stripe_logo.png' | assetsPath" alt="Stripe" />
        </div>
    </form>

    <ng-template #errorTmpl>
        <i class="adspt-error-icon">
            <svg class="adspt-icon icon-error">
                <use xlink:href="#adspt-error"></use>
            </svg>
        </i>
    </ng-template>
</ng-container>
